import { v4 as uuid } from "uuid";
import { useDispatch } from "react-redux";
import { uiSlice } from "../slices/uiSlice.jsx";

export const useNotify = () => {
  let dispatch = useDispatch();
  return ({ message, type }) => {
    let id = uuid();
    dispatch(uiSlice.actions.addNotification({ message, type, id }));

    setTimeout(() => {
      dispatch(uiSlice.actions.removeNotification(id));
    }, 1000);
  };
};
